export default {
  noDescription: 'Ingen beskrivelse',
  start: 'Start',
  plannedStart: 'Planlagt start av batch'
};
